import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import axios from 'axios';
import { _axios } from '../../../utils/axios'; 
import { ServerPath } from '../../../Constant';
// import {uploadImage} from "../../../Services/azure-storage-blob";
import {uploadImage} from '../../../Services/r2-storage-blob.js';



const EditTag = (props) => {
    const [show, setShow] = useState(false);
    const [tagId, setTagId] = useState(props?.data?.tag_id);
    const [tagName, setTagName] = useState('');
    const [tagStatus, setTagStatus] = useState(props?.data?.status);
    const [file, setFile] = useState(null);
    const [currentImageUrl, setCurrentImageUrl] = useState(props?.data?.image || '');


    useEffect(() => {
        const extractTextFromElement = (element) => {
            if (typeof element === 'string') {
                return element;
            } else if (element?.props && element?.props?.children) {
                if (Array.isArray(element?.props?.children)) {
                    return element?.props?.children.map(extractTextFromElement).join(' ');
                } else {
                    return extractTextFromElement(element?.props?.children);
                }
            }
            return '';
        };

        const nameElement = props?.data?.tag_name;
        const nameText = extractTextFromElement(nameElement);
        setTagName(nameText);
    }, [props?.data?.tag_name]);

    const handleClose = () => setShow(false);
    const handleShow = (event) => {
        event.preventDefault();
        setShow(true);
    };

    const handleFileChange = (event) => {
        setFile(event.target.files[0]);
    };

 const handleSubmit = async (event) => {
        event.preventDefault();
        let imageUrl = currentImageUrl;

        if (file) {
            const filename = `tag_${tagId}_${Date.now()}`;
            imageUrl = await uploadImage(file, filename, 'tags', 'images');
        }

        try {
            const response = await _axios.patch(`${ServerPath}/tag`, {
                tag_id: tagId,
                tag_name: tagName,
                status: tagStatus,
                image: imageUrl,
            });

            console.log(response.data);
            handleClose();
            window.location.reload();
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <>
            <Button onClick={handleShow} className="btn-square btn btn-primary mx-2"><i className='icon-pencil-alt'></i></Button>

            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Edit Tag</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form id='EditTagForm' onSubmit={handleSubmit}>
                        <Row>
                            <Form.Group as={Col} controlId='formGridTagName'>
                                <Form.Label>Tag Name</Form.Label>
                                <Form.Control
                                    type='text'
                                    value={tagName}
                                    onChange={(e) => setTagName(e.target.value)}
                                />
                            </Form.Group>
                        </Row>
                        <Row>
                            <Form.Group as={Col} controlId='formGridStatus'>
                                <Form.Label>Status</Form.Label>
                                <Form.Control
                                    as="select"
                                    value={tagStatus}
                                    onChange={(e) => setTagStatus(Number(e.target.value))}
                                >
                                    <option value={1}>Active</option>
                                    <option value={0}>Inactive</option>
                                </Form.Control>
                            </Form.Group>
                        </Row>
                        <Row className="mt-3">
                            <Form.Group as={Col} controlId='formGridImage'>
                                <Form.Label>Tag Image</Form.Label>
                                <Form.Control
                                    type='file'
                                    onChange={handleFileChange}
                                />
                            </Form.Group>
                        </Row>
                        {/* {currentImageUrl && (
                            <Row className="mt-3">
                                <Col>
                                    <img src={currentImageUrl} alt="Current Tag" style={{ maxWidth: '200px' }} />
                                </Col>
                            </Row>
                        )} */}
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>Close</Button>
                    <Button form='EditTagForm' variant="primary" type='submit' onClick={handleSubmit}>Update</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default EditTag;
